import { render, staticRenderFns } from "./useSensationList.vue?vue&type=template&id=367a0bf0&"
import script from "./useSensationList.vue?vue&type=script&lang=js&"
export * from "./useSensationList.vue?vue&type=script&lang=js&"
import style0 from "./useSensationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports